import PropTypes from 'prop-types';

export const accountsForAddPayeePropTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
};

const validationShape = {
	isValid: PropTypes.bool.isRequired,
	showValidation: PropTypes.bool,
	message: PropTypes.string,
};

export const validationPropTypes = {
	linkAccount: PropTypes.shape(validationShape),
	name: PropTypes.shape(validationShape),
	sortCode: PropTypes.shape(validationShape),
	accountNumber: PropTypes.shape(validationShape),
	reference: PropTypes.shape(validationShape),
	displayName: PropTypes.shape(validationShape),
};

export const addPayeeFormPropTypes = {
	linkAccount: PropTypes.string,
	name: PropTypes.string,
	sortCode: PropTypes.string,
	accountNumber: PropTypes.string,
	reference: PropTypes.string,
	displayName: PropTypes.string,
};

export const linkAccountDetailsPropTypes = {
	id: PropTypes.string,
	sortCode: PropTypes.string,
	accountNumber: PropTypes.string,
};

export const errorsPropTypes = PropTypes.oneOfType([
	PropTypes.shape({
		showError: PropTypes.bool,
		errorCode: PropTypes.string,
	}),
	PropTypes.shape({
		showError: PropTypes.bool,
		id: PropTypes.string,
		code: PropTypes.string,
		message: PropTypes.string,
	}),
]);

export const internationalAddPayeevalidationPropTypes = {
	linkAccount: PropTypes.shape(validationShape),
	internationalPayeeName: PropTypes.shape(validationShape),
	reference: PropTypes.shape(validationShape),
	displayName: PropTypes.shape(validationShape),
	payeeAddressLine1: PropTypes.shape(validationShape),
	payeeCity: PropTypes.shape(validationShape),
	payeeCountry: PropTypes.shape(validationShape),
	iban: PropTypes.shape(validationShape),
	internationalAccountNumber: PropTypes.shape(validationShape),
	bankName: PropTypes.shape(validationShape),
	bankAddressLine1: PropTypes.shape(validationShape),
	bankCity: PropTypes.shape(validationShape),
	bankCountry: PropTypes.shape(validationShape),
};

export const validationPropsProtoTypes = {
	validations: PropTypes.shape(internationalAddPayeevalidationPropTypes).isRequired,
	updateValidation: PropTypes.func.isRequired,
	hideErrorMsg: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	onFocusCheck: PropTypes.bool.isRequired,
};

export const addressFieldPropTypes = {
	id: PropTypes.string.isRequired,
	value: PropTypes.string,
	payeeAddressLine1: PropTypes.string,
	payeeAddressLine2: PropTypes.string,
	payeeCity: PropTypes.string,
	payeePostalCode: PropTypes.string,
	payeeCountry: PropTypes.string,
	bankAddressLine1: PropTypes.string,
	bankAddressLine2: PropTypes.string,
	bankCity: PropTypes.string,
	bankPostalCode: PropTypes.string,
	bankCountry: PropTypes.string,
	component: PropTypes.func,
};

export const ibanFieldPropTypes = {
	id: PropTypes.string.isRequired,
	value: PropTypes.string,
	iban: PropTypes.string,
};

export const internationalAccountNumberFieldPropTypes = {
	id: PropTypes.string.isRequired,
	value: PropTypes.string,
	internationalAccountNumber: PropTypes.string,
};

export const bickOrSwiftFieldPropTypes = {
	id: PropTypes.string.isRequired,
	value: PropTypes.string,
	bickOrSwift: PropTypes.string,
};

export const clearingCodeFieldPropTypes = {
	id: PropTypes.string.isRequired,
	value: PropTypes.string,
	clearingCode: PropTypes.string,
};

export const bankNameFieldPropTypes = {
	id: PropTypes.string.isRequired,
	value: PropTypes.string,
	bankName: PropTypes.string,
};

export const paymentReasonFieldPropTypes = {
	id: PropTypes.string.isRequired,
	value: PropTypes.string,
};

export const addInternationalPayeeFormPropTypes = {
	linkAccount: PropTypes.string,
	internationalPayeeName: PropTypes.string,
	displayName: PropTypes.string,
	singleUse: PropTypes.bool,
	showError: PropTypes.bool,
	errorCode: PropTypes.string,
	payeeAddressLine1: PropTypes.string,
	payeeAddressLine2: PropTypes.string,
	payeeCity: PropTypes.string,
	payeePostalCode: PropTypes.string,
	payeeCountry: PropTypes.string,
	payeeAccountType: PropTypes.string,
	iban: PropTypes.string,
	internationalAccountNumber: PropTypes.string,
	paymentReason: PropTypes.string,
	bickOrSwift: PropTypes.string,
	clearingCode: PropTypes.string,
	noBicOrSwift: PropTypes.bool,
	bankAddressLine1: PropTypes.string,
	bankAddressLine2: PropTypes.string,
	bankCity: PropTypes.string,
	bankPostalCode: PropTypes.string,
	bankCountry: PropTypes.string,
	bankName: PropTypes.string,
};
